import React from "react";
import { motion } from "framer-motion";
import { sound } from "../lib/sounds";

// Tactile "squishy" button with a colored bottom edge that compresses on press.
export const SquishyButton = ({
  children, onClick, color = "#38BDF8", edge = "#0284C7",
  className = "", textClass = "text-white", disabled = false,
  playSound = true, type = "button", ...rest
}) => {
  const handle = (e) => {
    if (disabled) return;
    if (playSound) sound.tap();
    onClick && onClick(e);
  };
  return (
    <motion.button
      type={type}
      disabled={disabled}
      whileTap={disabled ? {} : { y: 4, scale: 0.98 }}
      whileHover={disabled ? {} : { scale: 1.03 }}
      onClick={handle}
      style={{ backgroundColor: color, boxShadow: `0 6px 0 ${edge}` }}
      className={`rounded-3xl px-6 py-4 font-display font-bold ${textClass} disabled:opacity-50 no-select ${className}`}
      {...rest}
    >
      {children}
    </motion.button>
  );
};

export default SquishyButton;
